import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { ItemResponse, SaveResponse } from 'helpers/interfaces';


interface IContext {
    isSaving: boolean
    isLoading: boolean,
    userGroup: UserGroup,
    isNew: boolean,

    saveUserGroup: (ticket: UserGroup) => Promise<void>
}

export let userGroupSchema = yup.object().shape({
    userGroupId: yup.string().default(''),
    code: yup.string().default('').required(),
    description: yup.string().default(""),
});

type UserGroup = yup.InferType<typeof userGroupSchema>;

export let UserGroupContext = React.createContext({} as IContext);

let { Provider } = UserGroupContext;

let UserGroupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let isNew = location.pathname.includes("/addnew")

    let [isSaving, setSaving] = useState(false);
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [userGroup, setUserGroup] = useState(userGroupSchema.getDefault())



    useEffect(() => {
        if (isNew === false)
            getUserGroup();

    }, [id, isNew])

    let getUserGroup = async () => {
        try {
            let res = await axios.get<ItemResponse<UserGroup>>('/api/UserGroup/GetUserGroup', { params: { id } });

            let { item } = res.data;
            setUserGroup(item);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    let saveUserGroup = async (UserGroup: UserGroup) => {
        try {
            setSaving(true);
            await axios.post<SaveResponse>('/api/UserGroup/SaveUserGroup', UserGroup);
            history.goBack();

        } catch (err) {

        } finally {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                isNew,
                isSaving,
                saveUserGroup,
                userGroup,
                isLoading
            }}
        >
            {children}
        </Provider>
    )
}

export default UserGroupProvider;